import { action, makeObservable } from 'mobx';

import { OpenStore } from 'stores/shared/OpenStore';

import { ColorSchemeStore } from './ColorSchemeStore';
import { FontSizeStore } from './FontSizeStore';
import { LineHeightStore } from './LineHeightStore';
import { PictureBlockStore } from './PictureBlockStore';

export class AccessibilityParamsStore extends OpenStore {
  readonly fontSizeStore = new FontSizeStore();
  readonly lineHeightStore = new LineHeightStore();
  readonly pictureBlockStore = new PictureBlockStore();
  readonly colorSchemeStore = new ColorSchemeStore();

  constructor() {
    super();

    makeObservable(this, {
      reset: action.bound,
    });
  }

  reset() {
    this.fontSizeStore.reset();
    this.lineHeightStore.reset();
    this.pictureBlockStore.reset();
    this.colorSchemeStore.reset();
  }

  close() {
    super.close();
    this.reset();
  }

  toggle() {
    super.toggle();

    if (!this.isOpen) {
      this.reset();
    }
  }
}
